import React from 'react'

export const MARK_COLOR = 'fontColor';

export function renderFontColorLeaf({ children, leaf }) {

    if (leaf[MARK_COLOR]) {
        const styles = {
            color: leaf[MARK_COLOR],
            fontSize: 'inherit'
        };
        return (
            <span style={styles}>
                {children}
            </span>
        );
    }

    return children
};

export const FontColorPlugin = () => ({
  renderLeaf: renderFontColorLeaf,
});
